import { GuestWeddingResponse } from '../../libs/gds-api-client';
import produce from 'immer';
import { WeddingWebsiteQuery } from '../../generated/graphql';

const emptyOption = {
  text: null,
  description: null,
  __typename: 'GDS_Option' as 'GDS_Option',
};

// Add __typename or apollo cache won't work
export const guestWeddingWithTypename = (cachedGW: WeddingWebsiteQuery['guestWedding'], data: GuestWeddingResponse) => {
  const updated = produce(cachedGW, draft => {
    if (draft) {
      draft.isPrivateRsvp = data.isPrivateRsvp;
      if (typeof data.rsvpPageHidden === 'boolean') {
        draft.rsvpPageHidden = data.rsvpPageHidden;
      }
      if (typeof data.allowGuestPreview === 'boolean') {
        draft.allowGuestPreview = data.allowGuestPreview;
      }

      if (data.questions && data.questions.length) {
        draft.questions = data.questions.map(question => {
          let options = null;
          if (question.options) {
            options = question.options.map(o => ({ ...emptyOption, ...o }));
          }
          return { ...question, __typename: 'GDS_Question', options };
        }) as any;
      } else {
        draft.questions = null;
      }
    }
  });
  return updated;
};
